// JOBE-0106: KPIStrip — four-pill strip rendered from the JOBE-0103
// `counts` block: tasks, documents, entities (sum across kinds),
// watchers.
//
// Tasks `N due` sub-line is deferred. The spec §"Tasks `N due`" pinned
// "derive from cache if present, else omit"; v1 page does not lift the
// Tasks sub-tab cache to here, so the sub-line is always omitted. Adding
// the wiring is a small follow-up — either thread the cached rows from
// the Tasks sub-tab up via context, or compute it server-side as a new
// rollup field. Tracked as a follow-up to JOBE-0106.

import React from 'react';

function entitiesTotal(entitiesByKind) {
  if (!entitiesByKind) return 0;
  return Object.values(entitiesByKind).reduce((a, b) => a + (typeof b === 'number' ? b : 0), 0);
}

function entitiesKindCount(entitiesByKind) {
  if (!entitiesByKind) return 0;
  return Object.keys(entitiesByKind).length;
}

export function KPIStrip({ counts }) {
  const tasks = counts?.tasks ?? 0;
  const documents = counts?.documents ?? 0;
  const entitiesByKind = counts?.entities_by_kind || {};
  const watchers = counts?.watchers ?? 0;
  const entityTotal = entitiesTotal(entitiesByKind);
  const kindCount = entitiesKindCount(entitiesByKind);

  return (
    <div className="project-kpi-strip" data-testid="project-kpi-strip">
      <div className="kpi-pill" data-testid="kpi-tasks">
        <span className="kpi-pill-count">{tasks}</span>{' '}
        <span className="kpi-pill-label">Tasks</span>
      </div>
      <div className="kpi-pill" data-testid="kpi-documents">
        <span className="kpi-pill-count">{documents}</span>{' '}
        <span className="kpi-pill-label">Documents</span>
      </div>
      <div className="kpi-pill" data-testid="kpi-entities">
        <span className="kpi-pill-count">{entityTotal}</span>{' '}
        <span className="kpi-pill-label">Entities</span>
        <span className="kpi-pill-sub muted"> · {kindCount} kinds</span>
      </div>
      <div className="kpi-pill" data-testid="kpi-watchers">
        <span className="kpi-pill-count">{watchers}</span>{' '}
        <span className="kpi-pill-label">Watchers</span>
      </div>
    </div>
  );
}
